/**
 * Full-page loading state (STEP 13) — the `Suspense` fallback for
 * every lazy-loaded route (`routes/AppRouter.tsx`). Distinct from
 * `GlobalLoader` (a thin top-of-page progress bar for background
 * activity while the current page stays visible/interactive).
 */
import type { JSX } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export function PageLoader(): JSX.Element {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="60vh" role="status" aria-live="polite">
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={36} />
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Stack>
    </Box>
  );
}
